import useDateFormatters from "@hooks/useDateFormatters"

import { faIcon } from "@utils/faIcon"

import { Icon } from "@atoms"

import { Table } from "@organisms"

import styles from "./SeenCell.module.scss"
import { SeenCellProps } from "./SeenCell.types"

export default function SeenCell(props: SeenCellProps) {
    const { value } = props

    const { formatDatetime } = useDateFormatters()

    if (!value) {
        return <Table.Cells.NoValueCell />
    }

    return (
        <div className={styles.base}>
            <Icon icon={faIcon({ name: "eye", style: "regular" })} size={12} container="fixedHeight" />
            <span title={`Last seen ${formatDatetime(value, "long")}`}>Seen</span>
        </div>
    )
}
